import {
    INNOVATION_FIELDS,
    INNOVATION_PROJECTS,
    MACROTREND,
    MEGATREND,
    READINESS_ASSESSMENT,
    RECOMMENDED_ACTION
} from '@/model/rating/analysis'

export default {
    header: {
        innovationTypeFilter: {
            none: 'no assignment'
        },
        [MACROTREND]: 'Macro-trend',
        [MEGATREND]: 'Mega-trend',
        [RECOMMENDED_ACTION]: 'Recommendation',
        [READINESS_ASSESSMENT]: 'Readiness assessment',
        [INNOVATION_FIELDS]: 'Innovation fields',
        [INNOVATION_PROJECTS]: 'Innovation projects',
        panel: 'Panel'
    },

    total: 'Total'
}
